const getRVSApiBase = () => {
  const isLocal = window.location.href.includes('localhost');
  if (isLocal) {
    return 'http://localhost:7800/edu';
  }
  return '/api/irl';
};

export default getRVSApiBase;
